import { render, staticRenderFns } from "./side-drawer.vue?vue&type=template&id=1f76dbc2&scoped=true"
import script from "./side-drawer.vue?vue&type=script&lang=js"
export * from "./side-drawer.vue?vue&type=script&lang=js"
import style0 from "./side-drawer.vue?vue&type=style&index=0&id=1f76dbc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f76dbc2",
  null
  
)

export default component.exports